import VSelectCourseDifficulty from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseDifficulty', VSelectCourseDifficulty),
};
